import { BlocksIconSocialYoutube } from 'blocks-nextjs/blocks-web-components/components/icon/icons/social-youtube';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSocialYoutube = createComponent({
  react: React,
  tagName: 'cat-icon-social-youtube',
  elementClass: BlocksIconSocialYoutube
});
